import * as Immutable from 'immutable';

import { LEARN_TUTORIALS_PAGE_PATH } from '../../shared/constants';

export const simulationSettingsToFilter = ['visualization'];
export const multiSimulationSettingsToFilter = [
  'visualization',
  'decay',
  'universe',
  'nanHandling',
  'neutralization',
  'pasteurization',
  'truncation',
  'unitHandling',
  'mode',
  'componentActivation',
  'lookback',
];

export const multiSimulationSettingsChildToFilter = [
  'language',
  'visualization',
  'region',
  'instrumentType',
  'delay',
  'mode',
  'componentActivation',
];

export const tooltipInfo = Immutable.fromJS({
  language: {
    label: 'editorSettingsForm.language',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgLanguage',
  },
  decay: {
    label: 'editorSettingsForm.labelDecay',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgDecay',
  },
  universe: {
    label: 'editorSettingsForm.labelUniverse',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgUniverse',
  },
  universeOverride: {
    label: 'editorSettingsForm.labelUniverseOverride',
    tooltipInfo: 'editorSettingsForm.MsgUniverseOverride',
  },
  selectionLimit: {
    label: 'editorSettingsForm.labelSelectionLimit',
    tooltipInfo: 'editorSettingsForm.MsgSelectionLimit',
  },
  neutralization: {
    label: 'editorSettingsForm.labelNeutralization',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgNeutralization',
  },
  truncation: {
    label: 'editorSettingsForm.labelTruncation',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgTruncation',
  },
  region: {
    label: 'editorSettingsForm.labelRegion',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgRegion',
  },
  instrumentType: {
    label: 'editorSettingsForm.labelInstrumentType',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgInstrumentType',
  },
  delay: {
    label: 'editorSettingsForm.labelDelay',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgDelay',
  },
  pasteurization: {
    label: 'editorSettingsForm.labelPasteurization',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgPasteurization',
  },
  unitHandling: {
    label: 'editorSettingsForm.labelUnitHandling',
    tooltipInfo: 'editorSettingsForm.MsgUnitHandling',
  },
  nanHandling: {
    label: 'editorSettingsForm.labelNanHandling',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgNanHandling',
  },
  selectionHandling: {
    label: 'editorSettingsForm.labelSelectionHandling',
    tooltipInfo: 'editorSettingsForm.MsgSelectionHandling',
  },
  componentActivation: {
    label: 'editorSettingsForm.labelComponentActivation',
    tooltipInfo: 'editorSettingsForm.MsgComponentActivation',
  },
  testPeriod: {
    label: 'editorSettingsForm.testPeriod',
    tooltipInfo: 'editorSettingsForm.MsgTestPeriod',
  },
  maxTrade: {
    label: 'editorSettingsForm.maxTrade',
    tooltipInfo: 'editorSettingsForm.MsgMaxTrade',
  },
  maxPosition: {
    label: 'editorSettingsForm.maxPosition',
    tooltipInfo: 'editorSettingsForm.MsgMaxPosition',
  },
  lookback: {
    label: 'editorSettingsForm.labelLookback',
    url: `${LEARN_TUTORIALS_PAGE_PATH}/create-alphas/simulation-settings`,
    tooltipInfo: 'editorSettingsForm.MsgLookback',
  },
});

export const disabledSettingsDefault = ['unitHandling', 'nanHandling', 'lookback'];

export const disabledSettingsPython = ['unitHandling', 'nanHandling'];

export const disabledSettingsFastExpr = ['lookback'];

// Add here the settings not used to a regular or a multi-simulation
const disabledSettingsRegular: any = ['universeOverride', 'selectionLimit', 'selectionHandling', 'mode', 'componentActivation'];

export const getDisabledSettings = (language: string) => {
  if (language === 'FASTEXPR') {
    return disabledSettingsFastExpr;
  }
  if (language === 'PYTHON') {
    return disabledSettingsPython;
  }
  return disabledSettingsDefault;
};

export const getSettingsGivenOtherSettings = (settingsData: any, settingsToFilter: any) =>
  settingsToFilter.reduce((map: any, key: string) => map.delete(key), settingsData);

export const getSettings = (settingsOptions: any, userData: any, settingsToFilter: any) => {
  if (settingsToFilter === undefined || settingsToFilter === null || settingsOptions === null || settingsOptions === undefined) {
    return Immutable.fromJS({});
  }
  let settings = settingsToFilter.reduce((map: any, key: string) => map.delete(key), settingsOptions);
  const validSettings = Object.keys(settings.toJS()).filter((key: string) => settingsOptions.getIn([key, 'type']) !== 'date');
  validSettings.map((key: string) => {
    let min: any;
    let max: any;
    let step: any;
    let value = userData.get(key);

    const type = settingsOptions.getIn([key, 'type']);

    if (type === 'string') {
      min = { min: settingsOptions.getIn([key, 'minValue']) };
      max = { max: settingsOptions.getIn([key, 'maxValue']) };
    }

    if (!value && value !== 0) {
      if (type === 'boolean') {
        value = false;
      } else if (type === 'float' || type === 'integer') {
        value = settingsOptions.getIn([key, 'minValue']);
        min = { min: settingsOptions.getIn([key, 'minValue']) };
        max = { max: settingsOptions.getIn([key, 'maxValue']) };
        step = type === 'float' ? { step: 0.01 } : { step: 1 };
      } else if (type === 'string') {
        // Attempt to find a default value for setting if it is required
        if (settingsOptions.getIn([key, 'required']) && (min || max)) {
          value = min?.min || max?.max;
        }
      } else {
        value = settingsOptions.getIn([key, 'choices']).flatten().get(0);
      }
    } else if (type === 'float' || type === 'integer') {
      min = { min: settingsOptions.getIn([key, 'minValue']) };
      max = { max: settingsOptions.getIn([key, 'maxValue']) };
      step = type === 'float' ? { step: 0.01 } : { step: 1 };
    }
    settings = settings.set(
      key,
      Immutable.fromJS({
        value: typeof value === 'number' ? value.toString() : value,
        hasError: false,
        ...(min && min),
        ...(max && max),
        ...(step && step),
      })
    );
  });

  return settings;
};

export const getSettingsToSimulate = (
  type: string,
  settingsOptions: any,
  tab: any,
  visualizationActive: boolean,
  withDisabledSettings = true
) => {
  if (settingsOptions === undefined || settingsOptions === null || settingsOptions === null || settingsOptions === undefined) {
    return Immutable.fromJS({});
  }
  let settings;

  if (withDisabledSettings) {
    const disabledSettings = getDisabledSettings(tab.getIn(['settings', 'language', 'value']));
    settings = disabledSettings.reduce((map: any, key: string) => map.delete(key), tab.get('settings'));
  } else {
    settings = tab.get('settings');
  }

  settings = type === 'REGULAR' ? settings.filter((_: any, setting: string) => !disabledSettingsRegular.includes(setting)) : settings;

  settings = settings
    .map((value: any, key: string) => {
      if (settingsOptions.getIn([key, 'type']) === 'integer' || key === 'delay') {
        return parseInt(value.get('value'), 10);
      } else if (settingsOptions.getIn([key, 'type']) === 'float') {
        return parseFloat(value.get('value'));
      } else if (settingsOptions.getIn([key, 'type']) === 'string' || settingsOptions.getIn([key, 'type']) === 'date') {
        return value.get('value');
      } else {
        return value.get('value');
      }
    })
    .toJS();

  return {
    type,
    settings: {
      ...settings,
      visualization: visualizationActive,
    },
    regular: tab.get('code') ? tab.get('code') : undefined,
    combo: tab.get('combo') ? tab.get('combo') : undefined,
    selection: tab.get('selection') ? tab.get('selection') : undefined,
  };
};

export const getSettingsToMultiSimulate = (
  type: string,
  settingsOptions: any,
  tab: any,
  tabChild: any,
  visualizationActive: boolean,
  withDisabledSettings = true
) => {
  if (settingsOptions === undefined || settingsOptions === null || settingsOptions === null || settingsOptions === undefined) {
    return Immutable.fromJS({});
  }

  const disabledSettings = getDisabledSettings(tab.getIn(['settings', 'language', 'value']));

  let settings;

  if (withDisabledSettings) {
    settings = disabledSettings.reduce((map: any, key: string) => map.delete(key), tab.get('settings').concat(tabChild.get('settings')));
  } else {
    settings = tab.get('settings').concat(tabChild.get('settings'));
  }

  settings = type === 'REGULAR' ? settings.filter((_: any, setting: string) => !disabledSettingsRegular.includes(setting)) : settings;

  settings = settings
    .map((value: any, key: string) => {
      if (settingsOptions.getIn([key, 'type']) === 'integer' || key === 'delay') {
        return parseInt(value.get('value'), 10);
      } else if (settingsOptions.getIn([key, 'type']) === 'float') {
        return parseFloat(value.get('value'));
      } else if (settingsOptions.getIn([key, 'type']) === 'string' || settingsOptions.getIn([key, 'type']) === 'date') {
        return value.get('value');
      } else {
        return value?.get('value') ?? value;
      }
    })
    .toJS();

  return {
    type: 'REGULAR',
    settings: {
      ...settings,
      visualization: visualizationActive,
    },
    regular: tabChild.get('code'),
  };
};

export const checkIfSettingsAreInvalid = (settingsChild: any, settingsParent: any, options: any) => {
  const instrumentType = settingsParent.getIn(['instrumentType', 'value']);
  const region = settingsParent.getIn(['region', 'value']);
  const possibleInvalidSettings = [
    {
      name: 'universe',
      value: settingsChild.get('universe'),
      path: ['universe', 'choices', 'instrumentType', instrumentType, 'region', region],
    },
    {
      name: 'neutralization',
      value: settingsChild.get('neutralization'),
      path: ['neutralization', 'choices', 'instrumentType', instrumentType, 'region', region],
    },
  ];
  let newSettings = settingsChild;
  possibleInvalidSettings.map((setting: any) => {
    const validValue =
      options.getIn(setting.path) &&
      options.getIn(setting.path).filter((possibleValue: any) => possibleValue.get('value') === setting.value.get('value'));
    const value = validValue && validValue.size > 0 ? setting.value.get('value') : options.getIn(setting.path.concat([0, 'value']));
    newSettings = newSettings.setIn([setting.name, 'value'], value);
  });

  return newSettings;
};
